import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { signinWithGoogle } from '../auth/auth';
import { useSession } from '../context/session/useSession';
import { GoogleProfile } from '@fd/common/frontend/loadUserFromLocalStorage';

export function GoogleButton() {
  const { session } = useSession();
  if (session) {
    // already logged in, don't bother
    return <></>;
  }

  return (
    <div className="inline-block pb-4 text-center">
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          console.log('GoogleLogin', credentialResponse);
          if (!credentialResponse.credential) {
            throw new Error('onSuccess but no credential');
          }
          const googleProfile = jwtDecode(
            credentialResponse.credential
          ) as GoogleProfile;

          // https://developers.google.com/identity/sign-in/web/backend-auth
          // https://oauth2.googleapis.com/tokeninfo?id_token=${credentialResponse.credential}
          console.log('GoogleLogin', { googleProfile });
          if (!googleProfile?.email_verified) {
            // TODO smth
            return;
          }
          await signinWithGoogle(credentialResponse.credential);
          // appendGoogleProfileInfo(googleProfile);
        }}
        onError={() => {
          console.error('Login Failed');
        }}
        auto_select
        useOneTap
      />
    </div>
  );
}
